import React, { useState } from 'react';
import { useParams } from 'react-router';
import DocumentCreate from 'pages/drive/documentcreate';
import styles from './preview.module.scss';


const DocumentPerivew = () => {
  let {documentId} = useParams();
  const [openFileCreate, setOpenFileCreate] = useState(true);
  return (
    <div className={styles.wrapper}>
      {openFileCreate && <DocumentCreate
        showComments={true}
        openFileCreate={openFileCreate}
        setOpenFileCreate={setOpenFileCreate}
        onClose={() => window.close()}
        documentId={documentId} />}
    </div>
  );
};

export default DocumentPerivew;
